export default {
    heading: "Regenerate Login QR Code",
    desc: "If your school uses the EdCity Simple Login Service, you can log in to the EdCity website without entering a password. You can also view the login QR code here or regenerate a new QR code for the EdCity login.",
    createdAt: "Creation Date",
    expireAt: "Expiry Date",
    lostQrcode: "Regenerate / Lost QR Code",
    downloadQrcode: "Download Login QR Code",
    printQrcode: "Print Login QR Code",
    confirmRegenContent: "Confirm to regenerate login QR code?",
    confirm: "Confirm",
    cancel: "Cancel",
    noQrcodeDesc: "If your school uses the EdCity Simple Login Service, you can log in to the EdCity website without entering a password. You can also view the login QR code here or regenerate a new QR code for the EdCity login.",
    noQrcode: "No valid login QR code. Please contact school admin to generate a QR code for you.",

}